import { type FC } from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';

interface ConfirmationDialogProps {
    opened: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    loading?: boolean;
    zIndex?: string | number;
    onCancel: VoidFunction;
    onConfirm: VoidFunction;
}

const zIndexModal = 'calc(var(--mantine-z-index-modal) + 1)';

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
    opened,
    title = 'Подтверждение',
    message = 'Вы уверены?',
    confirmText = 'Да',
    cancelText = 'Нет',
    loading = false,
    zIndex = zIndexModal,
    onCancel,
    onConfirm,
}) => {
    return (
        <Modal
            opened={opened}
            title={title}
            zIndex={zIndex}
            withinPortal
            closeOnEscape={!loading}
            closeOnClickOutside={!loading}
            onClose={onCancel}
            centered
        >
            <Stack gap='md'>
                <Text>{message}</Text>

                <Group justify='flex-end'>
                    <Button
                        title={cancelText}
                        variant='default'
                        disabled={loading}
                        onClick={onCancel}
                    >
                        {cancelText}
                    </Button>

                    <Button
                        title={confirmText}
                        color='red'
                        loading={loading}
                        disabled={loading}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
};
